exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-invalid .custom-file-label{border:1px solid #dc3545}.uploadImage{width:100px}div.input-attach-wrapper{max-width:380px}div.input-attach-wrapper span.form-file-text{color:#495057;font-size:.75rem;line-height:24px}", ""]);

// exports
